import styled, {css} from 'styled-components'

export const PictureContainer = styled.span`
  display: block;
  position: relative;
  ${({isBackgroundImage}) => (isBackgroundImage ? 'height: inherit;' : '')};
`

export const StyledPicture = styled.picture`
  display: block;
  transition: opacity 500ms;
  ${({isBackgroundImage}) => (isBackgroundImage ? 'height: inherit;' : '')};
  ${({preview}) =>
    preview
      ? css`
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        `
      : ''};
  ${({loaded, preview}) =>
    loaded && preview
      ? css`
          opacity: 0;
        `
      : ''};
`

export const StyledImg = styled.img`
  display: block;
  ${({objectFit, objectPosition, height}) =>
    objectFit
      ? css`
          height: ${height
            ? css`
                ${height}px
              `
            : '100%'};
          width: 100%;
          object-fit: ${objectFit};
          object-position: ${objectPosition};
          font-family: 'object-fit: ${objectFit}; object-position: ${objectPosition};';
        `
      : ''}
`
